import React, { useEffect, useRef, useState } from "react";
import { FiCheck, FiMoreVertical, FiTrash2, FiXCircle } from "react-icons/fi";
import {
  appointmentId,
  isAppointmentPending,
  updateAppointmentStatus,
} from "./appointmentHelpers";

function AppointmentActionsMenu({
  item,
  token,
  onStatusUpdated,
  onDelete,
  onError,
}) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const rootRef = useRef(null);
  const id = appointmentId(item);
  const pending = isAppointmentPending(item);

  useEffect(() => {
    if (!open) return undefined;
    const onPointer = (event) => {
      if (!rootRef.current?.contains(event.target)) {
        setOpen(false);
      }
    };
    const onKey = (event) => {
      if (event.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onPointer);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onPointer);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const runStatusUpdate = async (status) => {
    if (!id || !token || busy) return;
    setOpen(false);
    setBusy(true);
    try {
      await updateAppointmentStatus({
        token,
        appointmentId: id,
        status,
      });
      onStatusUpdated?.(item, status);
    } catch (err) {
      onError?.(err?.message || `Could not mark appointment as ${status}.`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className={`dd-appt-actions${open ? " is-open" : ""}`}
      ref={rootRef}
      onClick={(e) => e.stopPropagation()}
    >
      {pending ? (
        <div className="dd-appt-actions__menu-wrap">
          <button
            type="button"
            className="dd-hours__icon-btn"
            aria-label="Appointment actions"
            aria-haspopup="menu"
            aria-expanded={open}
            disabled={!id || busy}
            onClick={() => setOpen((value) => !value)}
          >
            <FiMoreVertical size={15} aria-hidden />
          </button>
          {open ? (
            <div className="dd-appt-actions__menu" role="menu">
              <button
                type="button"
                role="menuitem"
                className="dd-appt-actions__item dd-appt-actions__item--approve"
                disabled={busy}
                onClick={() => runStatusUpdate("approved")}
              >
                <FiCheck size={14} aria-hidden />
                Approve
              </button>
              <button
                type="button"
                role="menuitem"
                className="dd-appt-actions__item dd-appt-actions__item--reject"
                disabled={busy}
                onClick={() => runStatusUpdate("rejected")}
              >
                <FiXCircle size={14} aria-hidden />
                Reject
              </button>
            </div>
          ) : null}
        </div>
      ) : null}
      <button
        type="button"
        className="dd-hours__icon-btn dd-hours__icon-btn--danger"
        aria-label="Delete appointment"
        onClick={() => onDelete?.(item)}
        disabled={!id || busy}
      >
        <FiTrash2 size={15} aria-hidden />
      </button>
    </div>
  );
}

export default AppointmentActionsMenu;
